/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Learn_MoreInputs */

const en_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more`)
};

const es_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saber más`)
};

const de_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahren Sie mehr`)
};

const zh_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多`)
};

const ar_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعرّف على المزيد`)
};

const fr_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apprendre encore plus`)
};

const vi_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm hiểu thêm`)
};

const sw_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jifunze zaidi`)
};

const th_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียนรู้เพิ่มเติม`)
};

const bs_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saznajte više`)
};

const ja_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳しくはこちら`)
};

const ko_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 알아보기`)
};

const pt_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba mais`)
};

const it_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per saperne di più`)
};

const sv_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lär dig mer`)
};

const nl_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer informatie`)
};

const da_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Læs mere`)
};

const nb_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les mer`)
};

const fi_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lue lisää`)
};

const pl_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Więcej informacji`)
};

const ru_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Узнать больше`)
};

const tr_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazlasını öğrenin`)
};

const hi_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिक जानें`)
};

const id_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari lagi`)
};

const ms_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari lebih banyak`)
};

const cs_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přečtěte si více`)
};

const el_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μάθετε περισσότερα`)
};

const he_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קראו עוד`)
};

const af_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer meer`)
};

const hu_method_learn_more = /** @type {(inputs: Method_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bővebben`)
};

/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Method_Learn_MoreInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_learn_more = /** @type {((inputs?: Method_Learn_MoreInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Learn_MoreInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_learn_more(inputs)
	if (locale === "de") return de_method_learn_more(inputs)
	if (locale === "zh") return zh_method_learn_more(inputs)
	if (locale === "ar") return ar_method_learn_more(inputs)
	if (locale === "fr") return fr_method_learn_more(inputs)
	if (locale === "vi") return vi_method_learn_more(inputs)
	if (locale === "sw") return sw_method_learn_more(inputs)
	if (locale === "th") return th_method_learn_more(inputs)
	if (locale === "bs") return bs_method_learn_more(inputs)
	if (locale === "ja") return ja_method_learn_more(inputs)
	if (locale === "ko") return ko_method_learn_more(inputs)
	if (locale === "pt") return pt_method_learn_more(inputs)
	if (locale === "it") return it_method_learn_more(inputs)
	if (locale === "sv") return sv_method_learn_more(inputs)
	if (locale === "nl") return nl_method_learn_more(inputs)
	if (locale === "da") return da_method_learn_more(inputs)
	if (locale === "nb") return nb_method_learn_more(inputs)
	if (locale === "fi") return fi_method_learn_more(inputs)
	if (locale === "pl") return pl_method_learn_more(inputs)
	if (locale === "ru") return ru_method_learn_more(inputs)
	if (locale === "tr") return tr_method_learn_more(inputs)
	if (locale === "hi") return hi_method_learn_more(inputs)
	if (locale === "id") return id_method_learn_more(inputs)
	if (locale === "ms") return ms_method_learn_more(inputs)
	if (locale === "cs") return cs_method_learn_more(inputs)
	if (locale === "el") return el_method_learn_more(inputs)
	if (locale === "he") return he_method_learn_more(inputs)
	if (locale === "af") return af_method_learn_more(inputs)
	if (locale === "hu") return hu_method_learn_more(inputs)
	return en_method_learn_more(inputs)
});